import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
export const exportToExcel = (data) => {
    console.log(data);

    if (!data || data?.data?.length === 0) return;

    const exportData = data?.data?.map((item, index) => ({
        "S.No": index + 1,
        "Name": `${item.name || ''} ${item.first_name || ''} ${item.last_name || ''}`.trim(),
        "Job Category": item.job_category?.category_name || '',
        "Mobile": item.mobile || '',
        "Mobile 2": item.mobile2 || '',
        "Email": item.email || '',
        "Location": item.location?.location_name || '',
    }));

    const worksheet = XLSX.utils.json_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Candidates");

    const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
    const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(blob, "Candidate_List.xlsx");
}; 